<template>
  <div class="pesel-search">
    <d-input
      type="number"
      :id="peselId"
      :value="value"
      :state="state"
      @input="handleInput"
      @click.native="toggleList"
      @blur.native="hideList"
    />
    <ul v-if="showList && options.length" class="pesel-search__list">
      <li
        v-for="option in options"
        :key="option.id"
        class="pesel-search__item"
        @mousedown.prevent="handleSelect(option)">
        {{ option.pesel }}
      </li>
    </ul>
    <div v-if="searched && !options.length && !loading && !value" class="p-2">Nie znaleziono pacjenta</div>
    <div v-if="loading" class="p-2">Szukam...</div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'pesel-search',
  props: {
    peselId: { type: String, default: '' },
    value: { type: String, default: '' },
    state: { type: [String, Boolean], default: null },
    options: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      showList: false,
      userTyped: false,
      searched: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.userTyped = false;
    });
  },
  created() {
    this.debouncedSearch = debounce((pesel) => {
      this.$emit('search', pesel);
    }, 500);
  },
  watch: {
    options(val) {
      if (this.userTyped && val.length > 0) {
        this.showList = true;
      }

      if (this.userTyped) {
        this.searched = true;
      }
    }
  },
  methods: {
    handleInput(pesel) {
      this.userTyped = true;
      this.searched = false;
      this.$emit('input', pesel);
      this.debouncedSearch(pesel);
    },
    hideList() {
      this.showList = false;
    },
    handleSelect(patient) {
      this.showList = false;
      this.userTyped = false;
      this.$emit('input', patient.pesel);
      this.$emit('selected', patient);
    },
    toggleList() {
      if (this.options.length && this.userTyped) {
        this.showList = !this.showList;
      }
    }
  }
}
</script>

<style lang="scss">
.pesel-search {
  position: relative;
}

.pesel-search__list {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  padding: 0;
  top: 35px;
  margin: 0;
  overflow-x: hidden;
  max-height: 100px;
  width: 100%;
  z-index: 99;
  li {
    list-style: none;
    padding: 7px 12px;

    max-height: 35px;
    &:not(:last-child) {
        margin-bottom: 5px;
    }

    &:hover {
      background-color: #007bff;
      color: #Fff;
      cursor: pointer;
    }
  }
}
</style>
